import http from '../assets/jslibs/axios/http';
import dkAxiosFile from '@/assets/jslibs/axios/axios-file';



//静默授权
export const WechatParLogin = (data) => {
  return http.post('/v1/app/WechatParLogin',data)
}



//获取验证码
export const getIdentifyCode = (data) => {
  return http.post('/v1/app/SendCode', data)
}

//登录
export const codeLogin = (data) => {
  return http.post('/v1/app/VerificationCodeLogin', data)
}

//密码登陆
export const AccountLogin = (data) => {
  return http.post('/v1/app/AccountLogin', data)
}


//获取七牛信息
// export const getCommunal = () => http.get('/v1/app/Communal');

export const getCommunal = () => {
  return http.get('/v1/app/Communal')
}


//获取个人信息
export const getUserInfo = () => {
  return http.get('/v1/app/UserInfo')
}

//修改个人信息
export const modifyUserInfo = (data,obj) => {
  return http.put(`/v1/app/UserInfo/${data}`, obj)
}



//上传小程序的openid
export const UpMinOpenid = (data) =>{
  return http.post('/v1/app/WechatApplet', data)
}

//微信绑定账号
export const WxBindAccount = (data) =>{
  return http.post('/v1/app/WxBindAccount', data)
}

//上传图片
export const uploadImg = data => dkAxiosFile({
  url: 'https://upload-z2.qiniup.com',
  headers: {
    'content-type': 'multipart/form-data',
  },
  method: 'POST',
  data,
})

//获取验证码
export const getCaptchaImage = function() {
  return http.get('/v1/app/captcha');
}



